<template>
  <top-page-table-header color="green" url="/receipts">
    <template v-slot:icon>
      <receipt-icn
        class="green-icon ml-2 mr-2"
        width="20px"
        height="20px"
        fill-rule="evenodd"
      ></receipt-icn>
      <span class="text-green text-lg font-bold"
        >未提出の領収書申請（{{ receiptsTop.length }}）</span
      >
    </template>

    <template v-slot:btn-content>
      <receipt-icn
        class="green-icon ml-4 mr-1"
        width="20px"
        height="20px"
        fill-rule="evenodd"
      ></receipt-icn>
      <div class="flex flex-row items-baseline">
        <span class="text-green text-lg font-bold">領収書</span>
        <span class="text-green text-sm font-bold">ページへ</span>
      </div>
    </template>
  </top-page-table-header>
  <app-table v-bind="$attrs" class="table-auto w-full">
    <template v-slot:table-body>
      <tr
        v-for="item in receiptsTop"
        :key="item.id"
        class="border border-collapse border-dashed border-green border-t-0 border-l-0 border-r-0 h-12 hover:bg-green-lightest"
        @click="openReceiptDialog(item.id)"
      >
        <td>
          <app-receipt-status-button
            class="status-btn border-4 border-green rounded-full mt-1 mb-1 px-1 bg"
            color="green"
            :status="item.option.viewType"
            style="width: 100px;"
            :isTopPage="true"
          ></app-receipt-status-button>
        </td>
        <td>
          <span class="text-black text-lg">{{
            $filters.dateFormat(item.createdAt)
          }}</span>
        </td>
        <td>
          <div class="flex flex-row items-center">
            <user-circle-icn
              width="20"
              height="20"
              class="green-icon-user"
            ></user-circle-icn>
            <span
              class="ml-1"
              v-if="item.user"
              :class="item.user.id === currentUser.id ? 'font-bold' : ''"
              >{{ item.user.uname }}</span
            >
          </div>
        </td>
        <td>
          <span class="text-black text-lg whitespace-nowrap"
            >{{ item.displayAmount.toLocaleString() }}円</span
          >
        </td>
      </tr>
    </template>
  </app-table>
</template>

<script>
import { onMounted } from 'vue'

import TopPageTableHeader from '@/components/layout/top/TopPageTableHeader'

import AppTable from '@/components/ui/AppTable'
import ReceiptIcn from '@/assets/icons/receipt.svg?inline'
import UserCircleIcn from '@/assets/icons/user-circle.svg?inline'
import AppReceiptStatusButton from '@/components/ui/AppReceiptStatusButton'
import { useCurrentUser } from '@/services/useCurrentUser'
import { useDialog } from '@/services/useDialog'
import { useReceiptDialog } from '@/services/receiptsYokohama/useReceiptDialog'
import { useTopData } from '@/services/useHome'

export default {
  name: 'TopPageReceiptTable_YOKOHAMA',

  components: {
    AppTable,
    ReceiptIcn,
    TopPageTableHeader,
    UserCircleIcn,
    AppReceiptStatusButton,
  },

  setup() {
    const { currentUser } = useCurrentUser()
    const { isOpen, type } = useDialog()
    const { getReceiptsTop, receiptsTop } = useTopData()

    onMounted(async () => {
      await getReceiptsTop()
    })

    return {
      currentUser,
      receiptsTop,
      isOpen,
      type,
      ...useReceiptDialog(),
    }
  },
}
</script>

<style lang="scss">
.green-icon-user {
  circle {
    fill: theme('colors.green.DEFAULT');
    fill-opacity: 1;
  }
}
</style>
